import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

// The bare enum value, wrapped in an object: synapse's `DefaultPayload` forbids a bare scalar.
export type ModelAssignmentClearedPayload = {
	usage: string;
};

export type ModelAssignmentClearedAction = {
	type: 'MODEL_ASSIGNMENT_CLEARED';
	payload: ModelAssignmentClearedPayload;
	scope: AssignmentScope;
};

export default (
	payload: ModelAssignmentClearedPayload,
	scope: AssignmentScope,
): ModelAssignmentClearedAction => ({
	type: 'MODEL_ASSIGNMENT_CLEARED',
	payload,
	scope,
});
